/**
 * pi-nonograms - A game of nonograms
 * https://github.com/DomenicoDeFelice/Pi-Nonograms
 *
 * Copyright (c) 2013-2020 Domenico De Felice
 * Released under the GNU GPL v3 License
 *
 * @license
 * @format
 * @flow
 */

class Event {
  _listeners: Array<Function> = [];
  _sender: any;

  constructor(sender?: any) {
    this._sender = sender;
  }

  attach = (listener: Function): void => {
    this._listeners.push(listener);
  };

  notify = (...args: Array<any>): void => {
    for (let i = 0, nListeners = this._listeners.length; i < nListeners; i++) {
      this._listeners[i](this._sender, ...args);
    }
  };
}

module.exports = Event;
